<template>
  <div>
    <h1>{{ $t('Connect to Social Media Platform') }}</h1>
    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2"
        ><h3>
          <i class="fab fa-facebook-square mr-2" /> {{ $t('Connect with') }} Facebook
        </h3></v-flex
      >
      <v-flex xs6>
        <div class="success--text pt-2 pl-2" v-if="selectedBot.page_access_token">
          {{ $t('Connected') }}
          <a
            v-if="
              selectedBot.pageid != selectedBot.facebook_page_id &&
                selectedBot.facebook_page_id != null
            "
            href="javascript:void(0);"
            @click="unlinkSocial('facebook')"
            outline
            color="primary"
            >({{ $t('Unlink') }})</a
          >
        </div>
        <div class="" v-else>
          <template v-if="!$store.state.facebook_info">
            <v-btn color="#3c5a99" :href="facebookUrl" dark depressed>
              <i class="fab fa-facebook-square mr-2" />{{ $t('Connect') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="#3c5a99" @click="showPageList = true" dark depressed>
              <i class="fab fa-facebook-square mr-2" />{{ $t('Connect') }}
            </v-btn>
          </template>
        </div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.page_access_token"
      class="arrow mt-2 "
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2 pa-2" style="display: inline-block">
        <v-avatar class="mr-2">
          <img
            class="responsive-img circle"
            style="min-width: 100%"
            alt
            @error="onError"
            :src="
              'https://graph.facebook.com/' +
                (selectedBot.facebook_page_id ? selectedBot.facebook_page_id : selectedBot.pageid) +
                '/picture?width=100&height=100&SameSite=None'
            "
          />
        </v-avatar>
        <span
          >{{
            selectedBot.facebook_page_name ? selectedBot.facebook_page_name : selectedBot.pagename
          }}
          ({{
            selectedBot.facebook_page_id ? selectedBot.facebook_page_id : selectedBot.pageid
          }})</span
        >
      </div>
      <v-divider />
      <div id="_instagram">
        <v-container>
          <v-layout style="position: relative">
            <v-flex xs6>
              <h3 class="middle mt-0">
                <!-- <div class="instagram" style="display: inline-block;"></div> -->
                <i class="fab fa-instagram mr-2" />
                <span>
                  {{ $t('Connect your chatbot on Instagram') }}
                  <v-premium-lock2
                    :value="!check_privilege('instagram')"
                    type="premium"
                  ></v-premium-lock2>
                </span>
              </h3>
            </v-flex>
            <v-flex xs6>
              <v-btn
                v-if="!selectedBot.instagram_business_account"
                depressed
                color="primary"
                :href="instagramUri"
                target="_blank"
                :disabled="!check_privilege('instagram')"
                >{{ $t('Connect') }}</v-btn
              >
              <div class="success--text pt-2 pl-2" v-else>
                {{ $t('Connected') }}
              </div>
            </v-flex>
          </v-layout>
          <div class=" pa-2" style="position: relative">
            <div
              v-if="selectedBot.instagram_business_account && selectedBot.instagram_name"
              class="mr-2 pa-2"
              style="display: inline-block"
            >
              <v-avatar class="mr-2">
                <img
                  class="responsive-img circle"
                  style="min-width: 100%"
                  alt
                  @error="onError"
                  :src="pictureUrlInstagram"
                />
              </v-avatar>
              <span
                >{{ selectedBot.instagram_name }} ({{
                  selectedBot.instagram_business_account
                }})</span
              >
            </div>
            <div>
              {{ $t('New! Instagram Automation is available now') }}
              <a
                href="https://blog.zwiz.ai/instagram-bot"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('read_tutorial') }}</a
              >
            </div>
          </div>
          <ConnectAccount />
        </v-container>
      </div>
    </div>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <h3>
          <i class="fab fa-line mr-2" />
          {{ $t('Connected ZWIZ AI Chatbot to Line Official Account') }}
        </h3></v-flex
      >
      <v-flex xs6>
        <div class="success--text pt-2 pl-2" v-if="selectedBot.line_modular_botid">
          {{ $t('Connected') }}
          <a
            v-if="selectedBot.pageid != selectedBot.line_modular_botid"
            href="javascript:void(0);"
            @click="unlinkSocial('line')"
            outline
            color="primary"
            >({{ $t('Unlink') }})</a
          >
        </div>
        <div v-else>
          <v-btn
            v-if="check_privilege('connect_line')"
            color="#06b901"
            :href="lineUrl"
            dark
            depressed
          >
            <i class="fab fa-line mr-2" />{{ $t('Connect') }}
          </v-btn>
          <v-btn v-else color="grey" outline>
            {{ $t('Connect')
            }}<v-premium-lock2
              :inline="true"
              class="ml-2"
              :value="!check_privilege('connect_line')"
              type="advanced"
              text="Upgrade to Advanced, starting at 990 baht / month to use this function"
            ></v-premium-lock2>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.line_modular_botid"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <template v-if="selectedBot">
          <LineProfile :pageid="selectedBot.pageid">
            <template v-slot="{ loading, botinfo }">
              <div class="text-xs-center" v-if="loading">
                <v-progress-circular indeterminate color="primary lighten-5"></v-progress-circular>
              </div>
              <template v-else>
                <template v-if="botinfo">
                  <v-avatar class="mr-2">
                    <img
                      class="responsive-img circle"
                      style="min-width: 100%"
                      alt
                      @error="onError"
                      :src="botinfo.pictureUrl || '/static/img/assets/livechat/profile.png'"
                    />
                  </v-avatar>
                  <span
                    >{{ botinfo.displayName || selectedBot.line_modular_botid }}
                    <template v-if="botinfo.basicId">({{ botinfo.basicId }})</template></span
                  >
                </template>
                <div class="error--text" v-else>
                  เกิดข้อผิดพลาด
                </div>
              </template>
            </template>
          </LineProfile>
        </template>
      </div>
    </div>

    <v-container>
      <v-layout>
        <v-flex xs6 class="pt-2">{{
          $t('Updating the latest account name and profile picture')
        }}</v-flex>
        <v-flex xs6>
          <v-btn outline @click="loadBotDetail" :loading="loadingDetail" color="primary">
            {{ $t('Update') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <h3>
          <i class="fab fa-whatsapp mr-2" />
          {{ $t('connected_whatsapp_account') }}
        </h3></v-flex
      >
      <v-flex xs6>
        <div class="success--text ma-2" v-if="selectedBot.whatsapp_account_id">
          {{ $t('Connected') }}
          <a
            v-if="selectedBot.pageid !== `whatsapp_${selectedBot.whatsapp_account_id}`"
            href="javascript:void(0);"
            @click="unlinkSocial('whatsapp')"
            outline
            color="primary"
            >({{ $t('Unlink') }})</a
          >
        </div>
        <div v-else>
          <v-btn
            outline
            v-if="check_privilege('connect_whatsapp')"
            @click="launchWhatsAppSignup"
            color="#06b901"
            dark
            depressed
          >
            <i class="fab fa-whatsapp mr-2" />{{ $t('Connect') }}
          </v-btn>
          <v-btn
            v-else
            color="grey"
            outline
            @click="openLink('https://m.me/361231620965547?ref=อัปเกรดWhatsapp')"
          >
            {{ $t('Connect')
            }}<v-premium-lock2
              :inline="true"
              class="ml-2"
              :value="!check_privilege('connect_whatsapp')"
              type="business"
              text="upgrade_to_business_to_use_this_function"
              url="https://m.me/361231620965547?ref=อัปเกรดWhatsapp"
            ></v-premium-lock2>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.whatsapp_account_id"
      class="arrow mt-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <v-layout wrap class="ma-2">
        <template v-if="selectedBot">
          <v-flex xs6 class="pt-2">
            <template v-if="selectedBot.whatsapp_account_id">
              <div class="mr-2" style="display: inline;">
                <img
                  class="responsive-img circle"
                  style="vertical-align: middle;"
                  width="40px"
                  alt
                  @error="onError"
                  :src="'/static/img/assets/icon/icon-whatsapp.png'"
                />
              </div>
              <span> {{ selectedBot.pagename }} ({{ selectedBot.whatsapp_account_id }}) </span>
            </template>
            <div class="error--text" v-else>
              เกิดข้อผิดพลาด
            </div>
          </v-flex>
          <v-flex xs6 class="pt-2">
            <template v-if="selectedBot.whatsapp_account_id">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    depressed
                    color="primary"
                    small
                    class="extra-small"
                    v-on="on"
                    style="margin-top: 10px; padding: 17px;"
                    @click="shareWhatsapp"
                  >
                    <i class="fas fa-share"></i>
                  </v-btn>
                </template>
                <span>{{ $t('Share WhatsApp account') }}</span>
              </v-tooltip>
            </template>
          </v-flex>
        </template>
      </v-layout>
      <div class="pa-3">
        {{ $t('whatsapp_is_available') }}
        <a
          href="https://blog.zwiz.app/whatsapp-messages/"
          target="_blank"
          rel="noopener noreferrer"
          >{{ $t('read_tutorial') }}</a
        >
      </div>
    </div>
    <v-container v-else>
      {{ $t('whatsapp_is_available') }}
      <a
        href="https://blog.zwiz.app/whatsapp-messages/"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t('read_tutorial') }}</a
      >
    </v-container>

    <div>
      <v-layout wrap class="mt-3">
        <v-flex xs6 class="pt-2">
          <h3>
            <i class="fab fa-google mr-2" />
            {{ $t('connect_google_account') }}
          </h3>
        </v-flex>
        <v-flex xs6>
          <div
            class="success--text pt-2 pl-2"
            v-if="selectedBot.google_agent_id && check_privilege('google')"
          >
            {{ $t('Connected') }}
          </div>
          <div v-else>
            <v-btn
              v-show="!googleEdit"
              v-if="check_privilege('google')"
              color="#ffb306"
              @click="googleEdit = true"
              dark
              depressed
            >
              <span class="fab fa-google mr-1"></span>
              {{ $t('Connect') }}
            </v-btn>
            <v-btn
              v-else
              color="grey"
              outline
              @click="openLink('https://m.me/361231620965547?ref=อัปเกรดGoogle')"
            >
              {{ $t('Connect')
              }}<v-premium-lock2
                :inline="true"
                class="ml-2"
                :value="!check_privilege('google')"
                type="business"
                text="upgrade_to_business_to_use_this_function"
                url="https://m.me/361231620965547?ref=อัปเกรดGoogle"
              ></v-premium-lock2>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <div v-if="(googleEdit || selectedBot.google_agent_id) && check_privilege('google')">
        <setting-google v-model="googleEdit"> </setting-google>
      </div>
    </div>

    <div>
      <v-layout wrap class="mt-3">
        <v-flex xs6 class="pt-2">
          <h3>
            <i class="fab fa-facebook-square mr-2" />
            {{ $t('connect_event_conversion') }}
          </h3>
        </v-flex>
        <v-flex xs6>
          <template v-if="selectedBot.advancedExpriedDate < 1">
            <v-btn color="grey" outline>
              {{ $t('Connect') }}
              <v-premium-lock2
                :inline="true"
                class="ml-2"
                :value="!check_privilege('event_conversion')"
                type="advanced"
                text="Upgrade to Advanced, starting at 990 baht / month to use this function"
              ></v-premium-lock2>
            </v-btn>
          </template>
          <template v-else>
            <div
              class="success--text pt-2 pl-2"
              v-if="check_privilege('event_conversion') && Boolean(selectedBot.facebook_mbe_token)"
            >
              {{ $t('Connected') }}
              <a
                href="javascript:void(0);"
                outline
                color="primary"
                @click="unlinkEventConversion()"
              >
                ({{ $t('Unlink') }})
              </a>
            </div>
            <div v-else>
              <v-btn color="primary" :href="eventConversionUrl">
                {{ $t('Connect') }}
              </v-btn>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="showPageList" persistent max-width="800" scrollable>
      <v-card id="social-connect">
        <div class="text-xs-right">
          <v-btn fab small flat @click="showPageList = false">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text style="height: 600px;">
          <template v-if="availablePages.length == 0">
            <v-container class="text-xs-center">
              <v-layout wrap>
                <v-flex xs12 sm6 offset-sm3>
                  <img
                    src="/static/img/assets/get_started/no_page.png"
                    alt
                    class="responsive-img"
                  />
                  <h2>{{ $t('You dont have any Facebook page or') }}</h2>
                  <h3>{{ $t('No permission to access Facebook page') }}</h3>
                  <v-btn
                    href="https://www.facebook.com/pages/creation/"
                    target="_blank"
                    block
                    class="mb-2 mt-2"
                    color="primary"
                  >
                    {{ $t('If you dont have any Facebook page, Create new page') }}</v-btn
                  >

                  <p>{{ $t('or') }}</p>

                  <v-btn @click="logout" block color="primary">
                    {{ $t('If you have page, Login again and Allow Facebook page permission') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
          <template v-else>
            <div>
              <div class="text-xs-center">
                <h2 class="primary--text" style="margin-bottom: 25px;">
                  {{ $t('Select your Facebook Page to install Zwiz.ai chatbot') }}
                </h2>

                <!-- <p style="margin_top: 45px; margin-bottom: 25px;">
                  {{ $t("Only Admin page can install Chatbot. The page doesn't show up") }}
                  <a
                    href="https://blog.zwiz.ai/%E0%B8%96%E0%B9%89%E0%B8%B2%E0%B9%80%E0%B8%9E%E0%B8%88%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89/"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ $t('click') }}</a
                  >
                </p> -->
              </div>

              <div class="pages">
                <div v-for="(page, index) in computedPage" :key="'page_' + page.id">
                  <page-item :isSocailConnect="true" v-model="computedPage[index]" class="page">
                    <div
                      slot="select-page"
                      style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; "
                      @click="onConfirmSubscribe(page)"
                    ></div>
                  </page-item>
                </div>
              </div>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalWhatsapp" persistent max-width="400">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showModalWhatsapp = false">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text class="text-center">
          <div class="d-flex justify-center"></div>
          <qrcode-view
            class="mb-4"
            style="text-align: center"
            :value="whatsappLink"
            :size="String(180)"
            level="H"
          />
          <textarea
            class="form-control pa-1"
            ref="shareLink"
            style="resize: vertical; width: 100%; border: 1px solid #eee;"
            onclick="this.select()"
            readonly="true"
            v-model="whatsappLink"
          ></textarea>
          <div class="text-xs-center">
            <v-tooltip v-model="showCopy" bottom color="success">
              <template v-slot:activator="{}">
                <v-btn
                  depressed
                  color="primary"
                  v-clipboard:copy="whatsappLink"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  <span class="glyphicon glyphicon-file mr-1"></span>
                  {{ $t('copy') }}
                </v-btn>
              </template>
              <span>{{ $t('Copied') }}</span>
            </v-tooltip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AES from 'crypto-js/aes'
import QrcodeView from 'qrcode.vue'
import config from '@/config'
import PageItem from '@/components/view/allbots/PageItem'
import LineProfile from '@/components/elements/LineProfile'
import ConnectAccount from '@/components/view/customAudience/ConnectAccount.vue'
import api from '@/api'
import SettingGoogle from './SettingGoogle'

window.fbAsyncInit = function() {
  // JavaScript SDK configuration and setup
  FB.init({
    appId: config.appid, // Facebook App ID
    cookie: true, // enable cookies
    xfbml: true, // parse social plugins on this page
    version: 'v15.0' //Graph API version
  })
}

// Load the JavaScript SDK asynchronously
;(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')
export default {
  components: {
    PageItem,
    LineProfile,
    ConnectAccount,
    SettingGoogle,
    QrcodeView
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      availablePages: 'availablePages',
      botlist: 'botlist'
    }),
    computedPage: function() {
      var pages
      try {
        pages = this.availablePages
        if (this.currentPageIndex == null) {
          this.currentPage = null
          return pages
        }
      } catch (error) {
        return []
      }
      try {
        return pages.filter(function(item) {
          if (item.id == this.currentPageIndex) {
            this.currentPage = item
          }
          return item.id == this.currentPageIndex
        })
      } catch (error) {
        console.error(error)
        return pages
      }
    }
  },
  data() {
    return {
      googleEdit: false,
      lineUrl: '',
      facebookUrl: '',
      eventConversionUrl: '',
      showPageList: false,
      loadingDetail: false,
      pictureUrlInstagram: null,
      instagramUri: '',
      checkBusiness: false,
      showModalWhatsapp: false,
      showCopy: false,
      whatsappLink: ''
    }
  },
  mounted() {
    this.checkBusiness = this.selectedBot.business_expireat ? true : false
    let line_connect_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/connectline`
    let fb_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/autofblogin`
    this.getInstagramDetail()
    let query = []
    let queryLoginIg = []

    queryLoginIg.push(`lang=${this.currentLang}`)
    for (const key in this.$route.query) {
      if (key != 'state') queryLoginIg.push(`${key}=${this.$route.query[key]}`)
    }
    let state = {
      userid: this.$store.state.userid,
      pageid: this.selectedBot.pageid,
      lang: this.currentLang,
      type: 'connect'
    }

    for (const key in state) {
      if (key != 'state' && key) query.push(`${key}=${state[key]}`)
    }

    let querystring = query.join(',')

    this.facebookUrl = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${
      config.appid
    }&scope=${
      config.fb_scope
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (query.length > 0) this.facebookUrl = this.facebookUrl + `&state={${querystring}}`

    this.instagramUri = `https://www.facebook.com/v13.0/dialog/oauth?client_id=${
      config.appid
    }&display=page&extras={"setup":{"channel":"IG_API_ONBOARDING"}}&redirect_uri=${encodeURIComponent(
      fb_redirect_uri
    )}&scope=${
      config.fb_scope
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (queryLoginIg.length > 0)
      this.instagramUri = this.instagramUri + `&state={${queryLoginIg.join(',')}}`

    let encrypt_query = ''

    encrypt_query = AES.encrypt(querystring, 'awesomezwizai').toString()
    this.lineUrl = `https://manager.line.biz/module/auth/v1/authorize?response_type=code&client_id=${this.$store.state.line.channelid}&redirect_uri=${line_connect_redirect_uri}&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=${encrypt_query}`

    const eventConversionExtras = {
      business_config: {
        business: {
          name: this.selectedBot.pageid
        }
      },
      repeat: false,
      setup: {
        business_vertical: 'ECOMMERCE',
        channel: 'MESSAGING_EVENTS',
        currency: 'THB',
        external_business_id: this.selectedBot.pageid,
        timezone: 'Asia/Bangkok'
      }
    }

    this.eventConversionUrl = `https://facebook.com/dialog/oauth?client_id=489929571406302&display=page&extras=${JSON.stringify(
      eventConversionExtras
    )}&redirect_uri=${origin}/callback/event-conversion&response_type=token&scope=manage_business_extension&state={lang=${this.$i18n.locale()}}`
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    },
    launchWhatsAppSignup() {
      const vm = this
      // Launch Facebook login
      window.FB.login(
        async function(response) {
          if (response.authResponse) {
            const accessToken = response.authResponse.accessToken
            console.log('Completed with token ' + accessToken)
            let res = await vm.post(`whatsapp/new-subscribe`, {
              pageid: vm.selectedBot.pageid,
              access_token: accessToken
            })
            if (res.success) {
              await vm.$swal.fire({
                title: vm.$t('Success'),
                type: 'success',
                confirmButtonText: vm.$t('Confirm')
              })
            } else {
              await vm.$swal.fire({
                type: 'error',
                title: vm.$t('Error')
              })
            }
            window.location.reload()
            //Use this token to call the debug_token API and get the shared WABA's ID
          } else {
            console.log('User cancelled login or did not fully authorize.')
          }
        },
        {
          scope: 'business_management,whatsapp_business_management,whatsapp_business_messaging',
          extras: {
            feature: 'whatsapp_embedded_signup',
            setup: {
              // Prefilled data can go here
            }
          }
        }
      )
    },
    async getInstagramDetail() {
      let res = await api.getInstagramDetail()
      if (res && res.instagram_business_account) {
        this.pictureUrlInstagram = res.instagram_business_account.profile_picture_url
      }
    },
    async loadBotDetail() {
      this.loadingDetail = true
      try {
        let response = await this.put(`page/${this.selectedBot.pageid}/refresh-page-info`)
        if (response.success) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
        } else {
          await this.$swal.fire({
            type: 'error',
            title: this.$t('Error')
          })
        }
        window.location.reload()
      } catch (error) {}
      this.loadingDetail = false
    },
    async unlinkSocial(channel) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to disconnect this social from this chatbot?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let data = {}

        try {
          let response = await this.delete(
            'admin/unlink-app',
            {
              params: {
                pageid: this.selectedBot.pageid,
                app: channel
              }
            },
            false
          )
          if (response.success) {
            await this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm')
            })
          }
          window.location.reload()
        } catch (error) {
          console.log(error)
        }
      }
    },
    async onConfirmSubscribe(page) {
      const vm = this
      if (page.isInstalled) {
        const result = await vm.$swal.fire({
          title: vm.$t('bot_id_exists_facebook'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          const resultSwal = await vm.$swal.fire({
            title: vm.$t('bot_id_exists_confirm_facebook'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })

          let data = {
            type: 'force_connect_facebook',
            page_access_token: page.access_token,
            from_page_id: page.id,
            to_page_id: vm.selectedBot.pageid
          }

          if (resultSwal.value) {
            let response = await vm.post('admin/connect', data, {})
            if (response.success) {
              await vm.$swal.fire({
                title: vm.$t('Success'),
                type: 'success',
                confirmButtonText: vm.$t('Confirm')
              })
              let newbotlist = vm.botlist
              newbotlist = newbotlist.filter(el => el.pageid !== page.id)
              vm.$store.dispatch('updateBotlist', newbotlist)
              window.location.reload()
              vm.showPageList = false
            }
          }
        }
      } else {
        let result = await this.$swal.fire({
          title: this.$t('Do you want to connect this social to this chatbot?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          let data = {
            adminid: this.$store.state.userid,
            pageid: this.selectedBot.pageid,
            page_access_token: page.access_token,
            type: 'connect_facebook_page'
          }
          try {
            let response = await this.post('admin/connect', data, {}, false)
            if (response.success) {
              await this.$swal.fire({
                title: this.$t('Success'),
                type: 'success',
                confirmButtonText: this.$t('Confirm')
              })
            }
            window.location.reload()
          } catch (error) {
            console.log(error)
          }
          this.showPageList = false
        }
      }
    },
    async shareWhatsapp() {
      if (!this.selectedBot.whatsapp_account_id) return
      try {
        const { result } = await this.get(`whatsapp/phone-numbers`, {
          params: {
            whatsapp_account_id: this.selectedBot.whatsapp_account_id
          }
        })
        if (result && result.data) {
          const findData = result.data.find(data => data.quality_rating === 'GREEN')
          if (findData && findData.display_phone_number) {
            this.whatsappLink = `https://wa.me/${findData.display_phone_number.replace(
              /[^a-zA-Z0-9]/g,
              ''
            )}`
            // console.log('this.whatsappLink: ', this.whatsappLink)
            this.showModalWhatsapp = true
          }
        }
        // this.whatsappLink = 'https://wa.me/66655136972'
        // this.showModalWhatsapp = true
      } catch (error) {}
    },
    onCopy() {
      this.showCopy = true
      setTimeout(() => {
        this.showCopy = false
      }, 3000)
    },
    onCopyError() {},
    logout() {
      var isFacebook = this.$store.state.isFacebook
      this.$store.dispatch('logout', null).then()
      if (isFacebook) {
        this.$router.push('/' + this.currentLang + '/login').catch(() => {})
      } else {
        this.$router.push('/' + this.currentLang + '/nigol').catch(() => {})
      }
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    async unlinkEventConversion() {
      this.$store.dispatch('loading')

      try {
        await this.delete(`page/${this.selectedBot.pageid}/revoke-facebook-mbe`, {
          facebook_mbe_token: null
        })
        this.selectedBot.facebook_mbe_token = null
      } catch (err) {
        await this.$swal.fire({
          title: this.$t('Error'),
          text: err,
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      } finally {
        this.$store.dispatch('loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// $size: 50px;
// .instagram {
//   /////// Use radial gradients to get the rounded
//   /////// gradient effect in each corner

//   ///// left bottom
//   background: radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%),
//     radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),
//     // left top
//       radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),
//     radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%),
//     //  right top
//       radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),
//     radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%),
//     // right bottom
//       radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),
//     /////// create a base coat to smooth
//       /////// corner gradients
//       linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%);

//   border-radius: 0.2em;
//   font-size: $size;
//   height: 1em;
//   position: relative;
//   width: 1em;

//   &:before,
//   &:after {
//     color: #fff;
//     content: '';
//     display: block;
//     position: absolute;
//     border: 0.075em solid;
//   }

//   &:before {
//     border-radius: inherit;
//     height: 0.75em;
//     transform: translate(0.125em, 0.125em);
//     width: 0.75em;
//   }

//   &:after {
//     border-radius: 1em;
//     box-shadow: 0.2em -0.2em 0 -0.16em;
//     height: 0.4em;
//     transform: translate(0.3em, 0.3em);
//     width: 0.4em;
//   }
// }

.middle {
  & > * {
    vertical-align: middle;
    line-height: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/SocialConnect.vue